import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Box, BoxProps, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { Lock03 } from "~/icons";
import { useGetSizeProps } from "./useGetSizeProps";
import { ArticleCardType } from "./utils";

interface TopicLabel {
  imageAlt: string;
  imgSrc: string;
  title: string;
}

interface Props {
  dek?: string;
  hasBoxShadow?: boolean;
  heroImageAlt: string;
  heroImageSrc: string;
  key?: string;
  isLocked?: boolean;
  linkPath: string;
  onClick?: () => void;
  onMouseOver?: () => void;
  styleProps?: {
    border?: BoxProps["border"];
  };
  title: string | ReactNode;
  topic: TopicLabel;
  type: ArticleCardType;
}

export const DumbArticleCard: FC<Props> = ({
  dek,
  hasBoxShadow = true,
  heroImageAlt,
  heroImageSrc,
  isLocked,
  key,
  linkPath,
  onClick,
  onMouseOver,
  styleProps = {},
  topic,
  title,
  type = "standard",
}) => {
  const sizeProps = useGetSizeProps(type);
  const showDek = type === "featured" && dek;

  return (
    <Flex
      as={Link}
      border={styleProps.border}
      boxShadow={hasBoxShadow ? "lg" : ""}
      direction="column"
      key={key}
      minH={sizeProps.height}
      h={sizeProps.height}
      minW={sizeProps.width}
      onClick={onClick}
      onMouseOver={onMouseOver}
      overflow="hidden"
      px={0}
      rounded="lg"
      to={linkPath}
      w={sizeProps.width}
    >
      <Box minH="50%" position="relative" w="100%">
        <Image
          alt={heroImageAlt}
          h="100%"
          objectFit="cover"
          position="absolute"
          src={heroImageSrc}
          w="100%"
        />
        {isLocked && (
          <Flex
            align="center"
            bgColor="rgba(0, 0, 0, 0.5)"
            color="white"
            h="100%"
            justify="center"
            position="absolute"
            w="100%"
          >
            <Lock03 color="white" h={5} w={5} />
          </Flex>
        )}
      </Box>
      <Box bg="white" minH="50%" pb={4} px={4} w="100%">
        <VStack mb=".5rem" spacing={1}>
          <Image
            alt={topic.imageAlt}
            h={sizeProps.topic.height}
            mt={sizeProps.topic.offset}
            src={topic.imgSrc}
            w={sizeProps.topic.width}
            zIndex={1}
          />
          <Text
            color="fg-accent-light"
            fontSize={sizeProps.topic.fontSize}
            fontWeight="bold"
            noOfLines={1}
            textAlign="center"
          >
            {topic.title}
          </Text>
        </VStack>
        <Text
          fontSize={sizeProps.fontSize}
          fontWeight="bold"
          minH="3.375rem"
          noOfLines={3}
          textAlign="center"
        >
          {title}
        </Text>
        {showDek && (
          <Text
            fontSize={sizeProps.topic.fontSize}
            fontWeight="light"
            my={4}
            noOfLines={4}
            textAlign="center"
          >
            {dek}
          </Text>
        )}
      </Box>
    </Flex>
  );
};
